import React from 'react';
import componentProps, { ComponentProps } from '../../helpers/componentProps';
import { applyComponentTheme } from '../../theme';
import { GridItem } from '../Grid';
import ShareButton from './ShareButton';
import { GridWithMargins, Heading, SharingButtons } from './styles';
import { ShareLogo, ShareType, SharingLink } from './types';

export type ShareWidgetProps = {
  title: string;
  logos: ShareLogo[];
  link: SharingLink;
} & ComponentProps;

const ShareWidget: React.FC<ShareWidgetProps> = ({ title, logos, link, ...props }) => {
  const filteredLogos = logos.filter(
    (logo) => !(logo.shareType === ShareType.PINTEREST && !link.image)
  );
  return (
    <GridWithMargins {...componentProps(props)}>
      <GridItem desktop={10} tabletLandscape={10}>
        <Heading tabIndex={0}>{title}</Heading>
        <SharingButtons>
          {filteredLogos.map((logo, index) => (
            <ShareButton key={`${logo.shareType}-${index}`} link={link} logo={logo} />
          ))}
        </SharingButtons>
      </GridItem>
    </GridWithMargins>
  );
};

export default applyComponentTheme(ShareWidget, 'ShareWidget');
